import React from 'react'
import Footer from '../component/Footer'

import paraThyroid from '../Media/img/Parathyroid.png'

const ParathyroidMedia = () => {
  return (
    <>
      <div className="headings">
        <h1>Parathyroid Media</h1>
      </div>

      <div style={{ width: '100%' }}>
        <img src={paraThyroid} style={{ width: '100%' }} />
      </div>


      <Footer />
    </>
  )
}

export default ParathyroidMedia
